import { render, staticRenderFns } from "./ContractsAndCancellation.vue?vue&type=template&id=58f262c8&scoped=true"
import script from "./ContractsAndCancellation.vue?vue&type=script&lang=js"
export * from "./ContractsAndCancellation.vue?vue&type=script&lang=js"
import style0 from "./ContractsAndCancellation.vue?vue&type=style&index=0&id=58f262c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f262c8",
  null
  
)

export default component.exports